import { Icon, Link } from '@vp/swan'
import { useTranslation } from 'react-i18next'

interface Props {
  allProjectsVisible: boolean
  isLoading?: boolean
  onShowMore: () => void
}

export const ProjectSelectionLinks = ({ allProjectsVisible, isLoading = false, onShowMore }: Props) => {
  const { t } = useTranslation()

  if (allProjectsVisible) {
    return null
  }

  const handleClick = () => {
    if (isLoading) return
    onShowMore()
  }

  return (
    <Link
      mt={3}
      onClick={handleClick}
      data-testid="show-more-projects-link"
      skin="unstyled"
      fontSkin="body-standard-bold"
      style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--swan-sem-space-between-icon-and-text)' }}
    >
      {t('contact_us.page.steps.issue_description.show_older_projects_link')}
      <Icon iconType="caretDown" />
    </Link>
  )
}
